var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEditMediumPurple = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7871 4.57662L11.4234 0.212938C11.1394 -0.0709792 10.679 -0.0709792 10.395 0.212938L0.213093 10.3949C0.0766921 10.5312 4.11912e-05 10.7162 0 10.909V15.2727C0 15.6744 0.325614 16 0.72728 16H5.09096C5.28383 16 5.46879 15.9233 5.60514 15.7869L15.7871 5.60499C16.071 5.32099 16.071 4.86062 15.7871 4.57662ZM4.79006 14.5454H1.45475V11.2101L8.72755 3.93732L12.0629 7.27262L4.79006 14.5454ZM9.75553 2.90896L13.0908 6.24426L14.2443 5.0908L10.909 1.75549L9.75553 2.90896Z",
    fill: "#AFAFE9"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEditMediumPurple);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/editMediumPurple.2c3c06b2db6d80b05160b978871a0e07.svg";